if (!customElements.get('cart-subscribe-popup')) {
  customElements.define(
    'cart-subscribe-popup',
    class CartSubscribePopup extends HTMLElement {
      connectedCallback() {
        this.mediaElement = this.querySelector('[data-role="media"]');
        this.titleElement = this.querySelector('[data-role="title"]');
        this.priceElement = this.querySelector('[data-role="price"]');
        this.subscribeButton = this.querySelector('[data-role="subscribe"]');
        this.continueButton = this.querySelector('[data-role="continue"]');
        this.dismissButton = this.querySelector('[data-role="dismiss"]');

        this.subscribeButton.addEventListener('click', this.handleSubscribeClick.bind(this));
        this.continueButton.addEventListener('click', () => this.hide());
        this.dismissButton.addEventListener('click', () => this.hide());

        this.handleProductAdded = this.handleProductAdded.bind(this);
        document.addEventListener('product-ajax:added', this.handleProductAdded);
        document.addEventListener('ajaxProduct:added', this.handleProductAdded);
      }

      disconnectedCallback() {
        document.removeEventListener('product-ajax:added', this.handleProductAdded);
        document.removeEventListener('ajaxProduct:added', this.handleProductAdded);
      }

      handleProductAdded(event) {
        const product = event.detail && event.detail.product;
        if (!product) return;

        const variantId = product.variant_id || product.id;
        if (!variantId) return;

        // The cart drawer body is re-rendered (server HTML) before this event
        // fires, so the line's own subscribe-toggle already reflects reality:
        // present + showing the "subscribe" button means eligible and not yet
        // subscribed. This avoids relying on fields /cart/add.js doesn't
        // actually return (selling_plan_allocations, line) - see cart-item's
        // own subscribe control for the source of truth.
        const cartItem = document.querySelector(`.cart-item[data-variant-id="${variantId}"]`);
        if (!cartItem) return;

        const toggle = cartItem.querySelector('cart-item-subscribe-toggle');
        const subscribeButton = cartItem.querySelector('.cart-item__subscribe-cta[data-role="subscribe"]');
        if (!toggle || !subscribeButton) return;

        this.pendingLineKey = toggle.dataset.lineKey;
        this.pendingQuantity = toggle.dataset.quantity;
        this.pendingSellingPlanId = subscribeButton.dataset.sellingPlanId;

        this.populate(product, toggle.dataset.discountPercent);
        this.show();
      }

      populate(product, discountPercent) {
        const imageUrl = (product.featured_image && product.featured_image.url) || product.image;
        const title = product.product_title || product.title || '';

        if (this.mediaElement) {
          this.mediaElement.innerHTML = imageUrl
            ? `<img src="${imageUrl}" alt="" width="100" height="100" loading="lazy">`
            : '';
        }

        if (this.titleElement) this.titleElement.textContent = title;

        if (this.priceElement) {
          const currentPrice = this.formatMoney(product.final_price != null ? product.final_price : product.price);
          const percent = parseFloat(discountPercent);

          this.priceElement.innerHTML =
            `<span class="cart-subscribe-popup__price-current">${currentPrice}</span>` +
            (percent > 0
              ? ` <span class="cart-subscribe-popup__price-compare">Save ${percent}%</span>`
              : '');
        }
      }

      formatMoney(cents) {
        if (window.FoxTheme && FoxTheme.Currency && typeof FoxTheme.Currency.formatMoney === 'function') {
          return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
        }
        return `$${(cents / 100).toFixed(2)}`;
      }

      show() {
        this.hidden = false;
      }

      hide() {
        this.hidden = true;
      }

      handleSubscribeClick() {
        if (!this.pendingLineKey) {
          this.hide();
          return;
        }

        this.subscribeButton.setAttribute('aria-disabled', 'true');
        this.subscribeButton.classList.add('btn--loading');

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        const body = JSON.stringify({
          id: this.pendingLineKey,
          quantity: this.pendingQuantity,
          selling_plan: this.pendingSellingPlanId,
          sections: sectionsToBundle,
        });

        fetch(`${FoxTheme.routes.cart_change_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.status || parsedState.errors) {
              console.error(parsedState.description || parsedState.message || parsedState.errors);
              return;
            }
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState });
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.subscribeButton.removeAttribute('aria-disabled');
            this.subscribeButton.classList.remove('btn--loading');
            this.hide();
          });
      }
    }
  );
}
